import axios from 'axios';
import config from '../config';

// API istekleri için temel axios instance'ı
const apiClient = axios.create({
  baseURL: config.API_BASE_URL_V1,
  headers: {
    'Content-Type': 'application/json',
  },
  maxRedirects: 5, // Maksimum 5 yönlendirmeye izin ver
  withCredentials: true, // CORS ile ilgili çerezleri gönder
});

// Token'ı her istekte otomatik ekleyen interceptor
apiClient.interceptors.request.use(
  (config) => {
    const userData = JSON.parse(localStorage.getItem('user_data'));
    if (userData?.token) {
      config.headers.Authorization = `Bearer ${userData.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Yanıt interceptor'ı - yönlendirmeleri ve hataları işle
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Hata detaylarını logla
    console.error('API Error:', error.message);
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);
    } else if (error.request) {
      console.error('Request made but no response received');
      console.error(error.request);
    }
    return Promise.reject(error);
  }
);

export default apiClient; 